import React from "react";
import PropTypes from "prop-types";

/** Components */
import Buttons from "../button/Buttons";
import SearchBar from "../../../components/ui/searchBar/SearchBar";
import "./CardSection.scss";

function CardSection({
  children,
  cardTitle,
  rightButton,
  customHeader,
  headerContent,
  buttonClassName,
  titleButtonClick,
  buttonText,
  searchInput,
  searchText,
  textWithIcon,
  iconImg,
  handleChange,
  isButtonVisible,
  isButtonLoading,
  isIcon,
  iconClass,
  isDisable,
}) {
  return (
    <div
      className={`card-section 
        ${cardTitle ? "card-section-left" : ""}
        ${searchInput && rightButton ? "card-section-between" : ""}
        ${rightButton ? "card-button-only" : ""}
        `}
    >
      {customHeader ? (
        <div className="card-top-title-btn">
          <div className="section-title">{cardTitle}</div>
          <div className="right-action">{headerContent}</div>
        </div>
      ) : (
        <>
          {(cardTitle || rightButton) && (
            <div className="card-top-title-btn">
              <div style={{ display: "flex", gap: "20px", alignItems: "center"}}>
                {cardTitle && <div className="section-title">{cardTitle}</div>}

                {searchInput && (
                  <div className="search-input">
                    <SearchBar searchText={searchText} onChange={handleChange} />
                  </div>
                )}
              </div>

              {isButtonVisible && rightButton && (
                <div className="btn-right-sec">
                  {/* Button to open the Add Craft modal */}
                  <Buttons
                    buttonTypeClassName={buttonClassName}
                    onClick={titleButtonClick}
                    buttonText={buttonText}
                    textWithIcon={textWithIcon}
                    imagePath={iconImg}
                    isLoading={isButtonLoading}
                    isIcon={isIcon}
                    iconClass={iconClass}
                    isDisable={isDisable}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}
      <div className="card-body-sec">{children}</div>
    </div>
  );
}

CardSection.propTypes = {
  children: PropTypes.node,
  cardTitle: PropTypes.string,
  rightButton: PropTypes.bool,
  buttonClassName: PropTypes.string,
  titleButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  searchInput: PropTypes.bool,
  searchText: PropTypes.string,
  textWithIcon: PropTypes.string,
  iconImg: PropTypes.string,
  handleChange: PropTypes.func,
  isButtonVisible: PropTypes.bool,
  isButtonLoading: PropTypes.bool,
  customHeader: PropTypes.bool,
  headerContent: PropTypes.node,
  isIcon: PropTypes.bool,
  iconClass: PropTypes.bool,
  isDisable: PropTypes.bool
};

export default CardSection;
